/**
 * Language Helper Utilities
 * 
 * These utilities help manage language parameters for API requests
 * and provide debugging capabilities.
 */

export const getCurrentLanguage = (): string => {
  if (typeof window === 'undefined') return 'en';
  return localStorage.getItem('language') || 'en';
};

export const setCurrentLanguage = (lang: 'ar' | 'en'): void => {
  if (typeof window === 'undefined') return;
  localStorage.setItem('language', lang);
};

/**
 * Adds language parameter to URL or params object
 * @param urlOrParams - URL string or params object
 * @returns URL with lang parameter or params object with lang
 */
export const addLanguageParam = (urlOrParams: string | Record<string, any>): string | Record<string, any> => {
  const lang = getCurrentLanguage();
  
  if (typeof urlOrParams === 'string') {
    // Handle URL string
    const separator = urlOrParams.includes('?') ? '&' : '?';
    return `${urlOrParams}${separator}lang=${lang}`;
  } else {
    // Handle params object
    return {
      ...urlOrParams,
      lang
    };
  }
};

/**
 * Debug function to log current language and API URLs
 */
export const debugLanguageParams = (): void => {
  const lang = getCurrentLanguage();
  console.log('🌐 Current Language:', lang);
  console.log('📝 Sample API URLs:');
  console.log(`  - Tenders: /api/tenders?lang=${lang}`);
  console.log(`  - Projects: /api/projects?lang=${lang}`);
  console.log(`  - Dashboard: /api/dashboard?lang=${lang}`);
  console.log(`  - Auth: /api/auth/me?lang=${lang}`);
};

// Export for use in components
export { getCurrentLanguage as default };
